/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_BookingsInputs */

const en_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookings`)
};

const de_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungen`)
};

const es_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas`)
};

const fr_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservations`)
};

const nl_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveringen`)
};

const it_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenotazioni`)
};

const pt_br2_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas`)
};

const pl_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje`)
};

const hu_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalások`)
};

const ro_admin_plan_discount_form_bookings = /** @type {(inputs: Admin_Plan_Discount_Form_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervari`)
};

/**
* | output |
* | --- |
* | "Bookings" |
*
* @param {Admin_Plan_Discount_Form_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_bookings = /** @type {((inputs?: Admin_Plan_Discount_Form_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_bookings(inputs)
	if (locale === "de") return de_admin_plan_discount_form_bookings(inputs)
	if (locale === "es") return es_admin_plan_discount_form_bookings(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_bookings(inputs)
	if (locale === "nl") return nl_admin_plan_discount_form_bookings(inputs)
	if (locale === "it") return it_admin_plan_discount_form_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_bookings(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_bookings(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_bookings(inputs)
	return ro_admin_plan_discount_form_bookings(inputs)
});
export { admin_plan_discount_form_bookings as "admin.plan_discount_form.bookings" }